import createClient, { type Middleware } from 'openapi-fetch'
import type { paths } from './api-types'
import { useAuthStore } from '../stores/authStore'

// Attaches the Tessera bearer token to every request, and clears the token on
// a 401 so the guard redirects to login.
const authMiddleware: Middleware = {
  onRequest({ request }) {
    const token = useAuthStore.getState().token
    if (token) request.headers.set('Authorization', `Bearer ${token}`)
    return request
  },
  onResponse({ response }) {
    if (response.status === 401) useAuthStore.getState().clear()
    return response
  },
}

// Same-origin: in the browser, requests go to the current origin (the reverse
// proxy / Vite dev proxy routes /v1 + /v3 to argos-api). An absolute base keeps
// URL parsing valid under jsdom too.
const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'

/** Typed client generated from the backend OpenAPI contract. */
export const api = createClient<paths>({
  baseUrl,
  // Defer to the current globalThis.fetch on each call (browser fetch in prod;
  // stubbable in tests) rather than capturing it once at module load.
  fetch: (...args: Parameters<typeof fetch>) => globalThis.fetch(...args),
})
api.use(authMiddleware)
